import { render, staticRenderFns } from "./MainNoticePopup.vue?vue&type=template&id=ad9b38f2&scoped=true"
import script from "./MainNoticePopup.vue?vue&type=script&lang=js"
export * from "./MainNoticePopup.vue?vue&type=script&lang=js"
import style0 from "./MainNoticePopup.vue?vue&type=style&index=0&id=ad9b38f2&scoped=true&lang=css"
import style1 from "./noticeCard.css?vue&type=style&index=1&id=ad9b38f2&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9b38f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad9b38f2')) {
      api.createRecord('ad9b38f2', component.options)
    } else {
      api.reload('ad9b38f2', component.options)
    }
    module.hot.accept("./MainNoticePopup.vue?vue&type=template&id=ad9b38f2&scoped=true", function () {
      api.rerender('ad9b38f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MainNoticePopup.vue"
export default component.exports